import { render } from "./AssignmentsTable.vue?vue&type=template&id=9de9f652&ts=true"
import script from "./AssignmentsTable.vue?vue&type=script&lang=ts"
export * from "./AssignmentsTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__